const { JOURNEY_TYPE } = require("../../constants");

const getIsLLDJourneySelected = journey => journey === JOURNEY_TYPE.LLD;

module.exports = { getIsLLDJourneySelected };
